import React from 'react';
import { getTheme, Icon, IStackItemStyles, Stack, StackItem, Text } from '@fluentui/react';
import { WhiteStatic } from 'theme';

interface FlowFormTitleProps {
  title: string;
  flowState: FlowState;
  flowStateNumber: number;
}

export enum FlowState {
  Active,
  InActive,
  Complete
}

export const FlowFormTitle: React.FC<FlowFormTitleProps> = props => {
  const { palette } = getTheme();

  const circle: Partial<IStackItemStyles> = {
    root: {
      bottom: 0,
      left: 0,
      borderRadius: 12,
      background: props.flowState === FlowState.InActive ? palette.neutralSecondary : palette.blue,
      height: 24,
      width: 24,
      content: '',
      margin: 12,
      paddingTop: 2,
      textAlign: 'center',
      color: props.flowState === FlowState.InActive ? palette.neutralLight : WhiteStatic
    }
  };

  const renderCircleContent = () => {
    switch (props.flowState) {
      case FlowState.Active:
        return props.flowStateNumber;
      case FlowState.InActive:
        return props.flowStateNumber;
      case FlowState.Complete:
        return <Icon iconName={'Accept'} />;
    }
  };

  return (
    <Stack horizontal style={{ alignItems: 'center', height: '100%' }}>
      <StackItem styles={circle}>
        <StackItem>{renderCircleContent()}</StackItem>
      </StackItem>
      <Text style={{ marginRight: 10 }}>{props.title}</Text>
    </Stack>
  );
};
